module.exports = __webpack_public_path__ + "static/media/ss-1@2x.8d5c124b.jpg";